/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Menu_OpenInputs */

const en_landing_menu_open = /** @type {(inputs: Landing_Menu_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

const pl_landing_menu_open = /** @type {(inputs: Landing_Menu_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz menu`)
};

/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Landing_Menu_OpenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_menu_open = /** @type {((inputs?: Landing_Menu_OpenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Menu_OpenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_menu_open(inputs)
	return en_landing_menu_open(inputs)
});